export const INVOICE_STATUS = {
  ANNULLED: 'A',
  IN_DEBIT: 'D',
  PAID: 'P',
  OFFER: 'O',
} as const
